"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainRecommendationSortColumn = void 0;
var TrainRecommendationSortColumn;
(function (TrainRecommendationSortColumn) {
    TrainRecommendationSortColumn["Position"] = "Position";
    TrainRecommendationSortColumn["Date"] = "Date";
    TrainRecommendationSortColumn["Recommendation"] = "Recommendation";
    TrainRecommendationSortColumn["Priority"] = "Priority";
    TrainRecommendationSortColumn["DepartmentName"] = "DepartmentName";
    TrainRecommendationSortColumn["PerformerName"] = "PerformerName";
    TrainRecommendationSortColumn["Rate"] = "Rate";
})(TrainRecommendationSortColumn || (exports.TrainRecommendationSortColumn = TrainRecommendationSortColumn = {}));
//# sourceMappingURL=sort.js.map